"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEditorSDKAdapter = void 0;
var tslib_1 = require("tslib");
var TOKEN = 'token';
var createEditorSDKAdapter = function (editorSDK, compRef) { return ({
    openColorPicker: function (options, onColorChanged) {
        return editorSDK.editor.openColorPicker(TOKEN, options, onColorChanged);
    },
    openFontPicker: function (options, onFontChanged) {
        return editorSDK.editor.openFontPicker(TOKEN, options, onFontChanged);
    },
    getSiteTextPresets: function () {
        return editorSDK.document.tpa.getSiteTextPresets(TOKEN, { compRef: compRef });
    },
    navigateToBilling: function (options) {
        return editorSDK.editor.openBillingPage(TOKEN, options);
    },
    setHelpArticle: function (articleId) {
        return editorSDK.editor.updatePanelOptions(TOKEN, { initialData: { articleId: articleId } });
    },
    getAllData: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a, _b, _c;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, editorSDK.document.controllers.getData(TOKEN, {
                        controllerRef: compRef,
                    })];
                case 1:
                    data = _d.sent();
                    // normalize the data between TPAWidget and Controller
                    if ((_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.COMPONENT) {
                        return [2 /*return*/, data.config];
                    }
                    return [2 /*return*/, (_c = (_b = data === null || data === void 0 ? void 0 : data.config) === null || _b === void 0 ? void 0 : _b.publicData) !== null && _c !== void 0 ? _c : { COMPONENT: {} }];
            }
        });
    }); },
    setData: function (key, value) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var data, componentData;
        var _a;
        var _b, _c, _d;
        return tslib_1.__generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, editorSDK.document.controllers.getData(TOKEN, {
                        controllerRef: compRef,
                    })];
                case 1:
                    data = _e.sent();
                    componentData = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.config) === null || _b === void 0 ? void 0 : _b.publicData) === null || _c === void 0 ? void 0 : _c.COMPONENT) !== null && _d !== void 0 ? _d : {};
                    return [2 /*return*/, editorSDK.document.controllers.saveConfiguration(TOKEN, {
                            config: {
                                publicData: {
                                    COMPONENT: tslib_1.__assign(tslib_1.__assign({}, componentData), (_a = {}, _a[key] = value, _a)),
                                },
                            },
                            controllerRef: compRef,
                        })];
            }
        });
    }); },
    removeData: function (key, scope) {
        return editorSDK.document.tpa.data.remove(TOKEN, { compRef: compRef, key: key, scope: scope });
    },
    getSiteColors: function () { return editorSDK.document.tpa.getSiteColors(TOKEN, { compRef: compRef }); },
    setBooleanParam: function (key, value, _a) {
        var isGlobal = _a.isGlobal;
        return editorSDK.document.tpa.setStyleParams(TOKEN, {
            compRef: compRef,
            styleParams: [{ type: 'boolean', key: key, param: { value: value } }],
            isGlobal: isGlobal,
        });
    },
    setFontParam: function (key, value, _a) {
        var isGlobal = _a.isGlobal;
        return editorSDK.document.tpa.setStyleParams(TOKEN, {
            compRef: compRef,
            styleParams: [{ type: 'font', key: key, param: { value: value } }],
            isGlobal: isGlobal,
        });
    },
    setNumberParam: function (key, value, _a) {
        var isGlobal = _a.isGlobal;
        return editorSDK.document.tpa.setStyleParams(TOKEN, {
            compRef: compRef,
            styleParams: [{ type: 'number', key: key, param: { value: value } }],
            isGlobal: isGlobal,
        });
    },
    setColorParam: function (key, value, _a) {
        var isGlobal = _a.isGlobal;
        return editorSDK.document.tpa.setStyleParams(TOKEN, {
            compRef: compRef,
            styleParams: [{ type: 'color', key: key, param: { value: value } }],
            isGlobal: isGlobal,
        });
    },
    getStyleParams: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, editorSDK.document.tpa.getStyleParams(TOKEN, { compRef: compRef })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); },
}); };
exports.createEditorSDKAdapter = createEditorSDKAdapter;
//# sourceMappingURL=editorSDKAdapter.js.map